import React from "react";
import { LocalizeText } from "components/localizer";
import { IMembership } from "reducers/memberships";
import { ListItemText, TextField } from "@mui/material";
import ListInlineEditWrapper from "../listComponents/listInlineEditWrapper";
import { usePermission } from "utils/hooks/usePermission";

interface IProps {
    membership: IMembership;
    onSubmitUpdate: (props: Record<string, unknown>) => void;
}

const PoNumberField: React.FC<IProps> = ({ membership, onSubmitUpdate }) => {
    const [poNumber, setPoNumber] = React.useState(membership.po_number || "");

    const { hasPermission } = usePermission();

    return (
        <ListInlineEditWrapper
            onChange={(e) => setPoNumber(e.target.value)}
            onSubmit={() => onSubmitUpdate({ po_number: poNumber })}
            label={<LocalizeText tag="poNumber" />}
            renderInput={(props) => <TextField {...props} value={poNumber} />}
            renderView={(props) => <ListItemText {...props} secondary={membership.po_number || "-"} />}
            inputIsValid={true}
            editDisabled={!hasPermission("change_membership") || !!membership.end_date || membership.is_archived}
        />
    );
};

export default PoNumberField;
